module.exports = __webpack_public_path__ + "static/media/page04_back.f30df724.png";